// Hover swatches text hiện lên ảnh img
let interval7 = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container');
  if (apElements && $('.apo-img-hover-text').length > 0){
    let productOptionSwatchArray = $('.avp-productoptionswatch-box');
    if (productOptionSwatchArray && productOptionSwatchArray.length > 0){
      for (let productOptionSwatch of productOptionSwatchArray){
      	let optionValueTitle = productOptionSwatch.nextSibling.innerHTML; // Option value name
        
        let spanOptionValueTitle = document.createElement('span');
        spanOptionValueTitle.setAttribute('class', 'swatches-img-subtitle');
        spanOptionValueTitle.innerHTML = optionValueTitle;
        productOptionSwatch.appendChild(spanOptionValueTitle);
      }
    }
    clearInterval(interval7);
  }
}, 100);

function forceQuitInterval7(){
  clearInterval(interval7);
}

setTimeout(forceQuitInterval7, 10000)